// 数组展平
export function flatten (arr) {
  return Array.isArray(arr) ? arr.reduce((a, b) => {
    return a.concat(flatten(b))
  }, []) : arr
}